import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold } from '../../../helpers/getEmailStyles';

class FeedbackMail extends React.Component {

    static propTypes = {
        content: PropTypes.shape({
            message: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    };

    render() {
        const { content: { message, name, logo, siteName } } = this.props;
        return (
            <Layout>
                <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
                <div style={body}>
                    <div style={fontWeightBold}>
                        Bonjour Admin,
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Vous avez reçu un retour de {name}. Veuillez examiner les détails ci-dessous :
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        {message}
                    </div>
                    <EmptySpace height={20} />
                    <EmailSignature siteName={siteName} />
                </div>
                <EmptySpace height={40} />
                <Footer siteName={siteName} />
                <EmptySpace height={20} />
            </Layout>
        );
    }

}

export default FeedbackMail;